import {deserialize, serialize, inheritSerialization} from 'cerialize';
import BaseUUIDEntity from './BaseUUIDEntity';

@inheritSerialization(BaseUUIDEntity)
export default class GuruPengajian extends BaseUUIDEntity {

  @serialize
  @deserialize
  public username: string = '';

  @serialize
  @deserialize
  public email: string = '';

  @serialize
  @deserialize
  public profile: string = '';

  @serialize
  @deserialize
  public phone: string = '';

  @serialize
  @deserialize
  public roles: Array<string> = [];
}

